"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Menu;
var React = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _Input = require("./form/Input");
var _Icon = _interopRequireDefault(require("./Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function Menu(props) {
  var onChange = function onChange(e, page, item) {
    var targetBlank = !!props.targetBlank;
    var x = e.ctrlKey && !targetBlank || !e.ctrlKey && targetBlank;
    if (!x || !item.url) {
      e.preventDefault();
      if (props.onChange) props.onChange(page, item);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-menu' + (props.layout || 'bar'), props.fixMargin && '-fix-top', props.className)
  }, props.items.map(function (item) {
    var page = item.page;
    var label = item.name;
    var itemProp = {
      key: 'm' + page,
      className: (0, _utils.clsNames)('un-menu' + (props.layout || 'bar') + '-item', page === props.value && '-active'),
      onClick: function onClick(e) {
        return onChange(e, page, item);
      },
      children: /*#__PURE__*/React.createElement(React.Fragment, null, !!item.icon && (0, _Input.testIcon)(item.icon), /*#__PURE__*/React.createElement("span", {
        className: "_label"
      }, label), !!item.count && /*#__PURE__*/React.createElement("span", {
        className: "_count"
      }, item.count), item.onDelete && /*#__PURE__*/React.createElement(_Icon.default, {
        button: true,
        name: 'times red _icon-del',
        onClick: item.onDelete
      }))
    };
    if (!!item.url) {
      itemProp.href = item.url;
      if (props.targetBlank || item.targetBlank) itemProp.target = '_blank';
    }
    return /*#__PURE__*/React.createElement(!!item.url ? 'a' : 'div', itemProp);
  }), props.children && /*#__PURE__*/React.createElement("div", {
    className: "un-menu-content"
  }, props.children));
}